export default {
  dentist: [
    {
      id: 0,
      value: 'Suspended'
    },
    {
      id: 1,
      value: 'Active'
    }
  ],
  enquiry: [
    {
      id: 'new',
      value: 'New',
      class: 'primary'
    },
    {
      id: 'open',
      value: 'Open',
      class: 'warning'
    },
    {
      id: 'successful',
      value: 'Successful',
      class: 'success'
    },
    {
      id: 'unsuccessful',
      value: 'Unsuccessful',
      class: 'danger'
    }
  ],
  ticket: [
    {
      id: 'new',
      value: 'New',
      class: 'primary'
    },
    {
      id: 'progress',
      value: 'In Progress',
      class: 'warning'
    },
    {
      id: 'resolved',
      value: 'Resolved',
      class: 'success'
    }
  ],
  request: [
    {
      id: 'new',
      value: 'New',
      class: 'primary'
    },
    {
      id: 'progress',
      value: 'In Progress',
      class: 'warning'
    },
    {
      id: 'resolved',
      value: 'Resolved',
      class: 'success'
    }
  ]
}
